import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { 
  Briefcase, 
  Clock, 
  CheckCircle, 
  XCircle,
  Loader2,
  Eye,
  Calendar,
  User,
  FileText,
  Building2,
  ArrowUpDown,
  Package,
  Minus,
  AlertTriangle,
  Plus,
  Download,
  Upload
} from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../components/ui/table';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '../../components/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../components/ui/popover';
import { Check, ChevronsUpDown, Search, ArrowLeftRight } from 'lucide-react';
import { cn } from '../../lib/utils';
import WorkJobs from '../work/WorkJobs';

const API = process.env.REACT_APP_BACKEND_URL;

const DepotJobs = ({ branchIdOverride, readOnly = false }) => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('assigned');
  const [loading, setLoading] = useState(true);
  
  // Jobs state
  const [assignedJobs, setAssignedJobs] = useState([]); // Bana atanan işler
  const [activeJobs, setActiveJobs] = useState([]);
  const [rejectedJobs, setRejectedJobs] = useState([]);
  const [completedJobs, setCompletedJobs] = useState([]);
  
  // Modal state
  const [selectedJob, setSelectedJob] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  
  // Stok Çıkış Modal state
  const [stockExitModalOpen, setStockExitModalOpen] = useState(false);
  const [stockList, setStockList] = useState([]);
  const [stockSearchTerm, setStockSearchTerm] = useState('');
  const [stockExitItems, setStockExitItems] = useState([
    { stok_karti_id: '', miktar: '', birim: '', urun_adi: '', mevcut_stok: 0, popoverOpen: false }
  ]);
  const [stockExitAciklama, setStockExitAciklama] = useState('');
  const [stockExitLoading, setStockExitLoading] = useState(false);
  
  // Talep Eden bilgileri state
  const [talepEdenId, setTalepEdenId] = useState('');
  const [talepEdenName, setTalepEdenName] = useState('');
  const [talepEdenPopoverOpen, setTalepEdenPopoverOpen] = useState(false);
  
  // Teslim bilgileri state
  const [teslimAlanId, setTeslimAlanId] = useState(''); // Seçilen kullanıcı ID'si
  const [teslimAlanName, setTeslimAlanName] = useState(''); // Seçilen kullanıcının adı
  const [teslimAlanUsers, setTeslimAlanUsers] = useState([]); // Kullanıcı listesi
  const [teslimAlanPopoverOpen, setTeslimAlanPopoverOpen] = useState(false);
  const [teslimTarihi, setTeslimTarihi] = useState('');
  const [teslimBelgeleri, setTeslimBelgeleri] = useState([]); // Çoklu belge desteği
  const [teslimBelgesiUploading, setTeslimBelgesiUploading] = useState(false);
  
  // Reddetme Modal state
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [rejectLoading, setRejectLoading] = useState(false);
  
  // Tamamlama Modal state
  const [completeModalOpen, setCompleteModalOpen] = useState(false);
  const [completeNotes, setCompleteNotes] = useState('');
  const [completeLoading, setCompleteLoading] = useState(false);
  
  // Depoya Transfer Modal state
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [transferDestinationBranch, setTransferDestinationBranch] = useState('');
  const [transferLoading, setTransferLoading] = useState(false);
  const [branchList, setBranchList] = useState([]);
  
  // Stok çıkış geçmişi state
  const [stockExitHistory, setStockExitHistory] = useState([]);
  const [stockExitHistoryLoading, setStockExitHistoryLoading] = useState(false);
  
  // İş belgeleri state
  const [jobDocuments, setJobDocuments] = useState([]);
  const [jobDocumentsLoading, setJobDocumentsLoading] = useState(false);
  
  // Firma seçimi state
  const [subcontractors, setSubcontractors] = useState([]);
  const [selectedFirma, setSelectedFirma] = useState('');
  const [firmaPopoverOpen, setFirmaPopoverOpen] = useState(false);
  const [firmaEmployees, setFirmaEmployees] = useState([]); // Seçilen firmanın çalışanları (teslim alan)
  
  // Sort state
  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'desc' });

  // İş Ekle (Add Job) modal state
  const [addJobModalOpen, setAddJobModalOpen] = useState(false);
  const [addJobSubmitting, setAddJobSubmitting] = useState(false);
  const [branchUsers, setBranchUsers] = useState([]);
  const [addJobForm, setAddJobForm] = useState({
    hedef: 'branch',
    konu: '',
    aciklama: '',
    tracking_users: [],
    belgeler: [],
  });
  const [trackingUsersPopoverOpen, setTrackingUsersPopoverOpen] = useState(false);

  // WorkJobs listesini depo aksiyonları sonrası yenilemek için sinyal
  const [reloadSignal, setReloadSignal] = useState(0);
  const triggerReload = () => setReloadSignal((s) => s + 1);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('fortis_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  };

  // Load assigned jobs (branch_jobs - tracking_users)
  const loadAssignedJobs = useCallback(async () => {
    try {
      const branchParam = branchIdOverride ? `?branch_id=${branchIdOverride}` : '';
      const response = await axios.get(`${API}/api/depot/my-assigned-jobs${branchParam}`, { headers: getAuthHeaders() });
      setAssignedJobs(response.data || []);
    } catch (error) {
      console.error('Atanan işler yüklenirken hata:', error);
    }
  }, [branchIdOverride]);

  // Load active jobs
  const loadActiveJobs = useCallback(async () => {
    try {
      const branchParam = branchIdOverride ? `?branch_id=${branchIdOverride}` : '';
      const response = await axios.get(`${API}/api/depot/jobs/active${branchParam}`, { headers: getAuthHeaders() });
      setActiveJobs(response.data || []);
    } catch (error) {
      console.error('Aktif işler yüklenirken hata:', error);
    }
  }, [branchIdOverride]);

  // Load rejected jobs
  const loadRejectedJobs = useCallback(async () => {
    try {
      const branchParam = branchIdOverride ? `?branch_id=${branchIdOverride}` : '';
      const response = await axios.get(`${API}/api/depot/jobs/rejected${branchParam}`, { headers: getAuthHeaders() });
      setRejectedJobs(response.data || []);
    } catch (error) {
      console.error('Reddedilen işler yüklenirken hata:', error);
    }
  }, [branchIdOverride]);

  // Load completed jobs
  const loadCompletedJobs = useCallback(async () => {
    try {
      const branchParam = branchIdOverride ? `?branch_id=${branchIdOverride}` : '';
      const response = await axios.get(`${API}/api/depot/jobs/completed${branchParam}`, { headers: getAuthHeaders() });
      setCompletedJobs(response.data || []);
    } catch (error) {
      console.error('Yapılan işler yüklenirken hata:', error);
    }
  }, [branchIdOverride]);

  // Mark page as seen for notifications
  const markPageAsSeen = useCallback(async () => {
    try {
      await axios.post(`${API}/api/depot/mark-seen/depot_jobs`, {}, { headers: getAuthHeaders() });
    } catch (error) {
      console.error('Mark seen hatası:', error);
    }
  }, []);

  // Initial load
  useEffect(() => {
    const loadAll = async () => {
      setLoading(true);
      await Promise.all([
        loadAssignedJobs(),
        loadActiveJobs(),
        loadRejectedJobs(),
        loadCompletedJobs()
      ]);
      setLoading(false);
      // Mark page as seen after loading
      markPageAsSeen();
    };
    loadAll();
  }, [loadAssignedJobs, loadActiveJobs, loadRejectedJobs, loadCompletedJobs, markPageAsSeen]);

  // Get status badge
  const getStatusBadge = (status) => {
    const statusMap = {
      'pending': { label: 'Bekliyor', className: 'bg-yellow-100 text-yellow-800' },
      'active': { label: 'Aktif', className: 'bg-blue-100 text-blue-800' },
      'in_progress': { label: 'Devam Ediyor', className: 'bg-indigo-100 text-indigo-800' },
      'completed': { label: 'Tamamlandı', className: 'bg-green-100 text-green-800' },
      'waiting_approval': { label: 'Onay Bekliyor', className: 'bg-amber-100 text-amber-800' },
      'rejected': { label: 'Reddedildi', className: 'bg-red-100 text-red-800' },
      'cancelled': { label: 'İptal Edildi', className: 'bg-gray-100 text-gray-800' }
    };
    return statusMap[status] || { label: status, className: 'bg-gray-100 text-gray-800' };
  };

  // Load stock exit history for a job
  const loadStockExitHistory = async (jobId) => {
    if (!jobId) return;
    setStockExitHistoryLoading(true);
    try {
      const response = await axios.get(`${API}/api/depot/stok-cikisleri/by-job/${jobId}`, { headers: getAuthHeaders() });
      setStockExitHistory(response.data || []);
    } catch (error) {
      console.error('Stok çıkış geçmişi yüklenirken hata:', error);
      setStockExitHistory([]);
    } finally {
      setStockExitHistoryLoading(false);
    }
  };

  // Load job documents
  const loadJobDocuments = async (jobId) => {
    if (!jobId) return;
    setJobDocumentsLoading(true);
    try {
      const response = await axios.get(`${API}/api/branch/jobs/${jobId}/documents`, { headers: getAuthHeaders() });
      setJobDocuments(response.data || []);
    } catch (error) {
      console.error('İş belgeleri yüklenirken hata:', error);
      // API hatası durumunda işin kendi belgelerini kullan
      setJobDocuments([]);
    } finally {
      setJobDocumentsLoading(false);
    }
  };

  // Load branches for transfer
  const loadBranches = async () => {
    try {
      const response = await axios.get(`${API}/api/branches`, { headers: getAuthHeaders() });
      setBranchList(response.data || []);
    } catch (error) {
      console.error('Şube listesi yüklenirken hata:', error);
    }
  };

  // Handle transfer to another depot
  const handleTransferToDepot = async () => {
    if (!selectedJob || !transferDestinationBranch) {
      toast.error('Hedef depo seçilmedi');
      return;
    }
    
    setTransferLoading(true);
    try {
      const response = await axios.post(
        `${API}/api/depot/jobs/${selectedJob.id}/forward-to-depot`,
        { destination_branch_id: transferDestinationBranch },
        { headers: getAuthHeaders() }
      );
      
      if (response.data.success) {
        toast.success(response.data.message || 'İş başarıyla transfer edildi');
        triggerReload();
        setTransferModalOpen(false);
        setDetailModalOpen(false);
        setTransferDestinationBranch('');
        // Reload jobs
        loadAssignedJobs();
      }
    } catch (error) {
      console.error('Transfer hatası:', error);
      toast.error(error.response?.data?.detail || 'Transfer işlemi başarısız');
    } finally {
      setTransferLoading(false);
    }
  };

  // Open transfer modal
  const openTransferModal = () => {
    loadBranches();
    setTransferModalOpen(true);
  };

  // Download document with auth
  const downloadDocument = async (doc) => {
    try {
      const response = await axios.get(`${API}/api/documents/${doc.id}/download`, {
        headers: getAuthHeaders(),
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', doc.name || doc.original_filename || 'belge');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Belge indirme hatası:', error);
      toast.error('Belge indirilemedi');
    }
  };

  // Get combined documents (from API + job's own documents field)
  const getCombinedDocuments = () => {
    const docs = [...jobDocuments];
    
    // İşin kendisinde documents alanı varsa ekle
    if (selectedJob?.documents && Array.isArray(selectedJob.documents)) {
      selectedJob.documents.forEach(doc => {
        // Base64 veya URL formatında olabilir
        if (doc.data || doc.url) {
          docs.push({
            id: doc.id || Math.random().toString(),
            name: doc.name || 'Belge',
            url: doc.url || (doc.data ? `data:${doc.type || 'application/octet-stream'};base64,${doc.data}` : ''),
            type: doc.type
          });
        }
      });
    }
    
    return docs;
  };

  // Sort jobs
  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const sortJobs = (jobs) => {
    if (!sortConfig.key) return jobs;
    return [...jobs].sort((a, b) => {
      let aVal = a[sortConfig.key] || '';
      let bVal = b[sortConfig.key] || '';
      if (sortConfig.key === 'created_at' || sortConfig.key === 'updated_at') {
        aVal = new Date(aVal).getTime();
        bVal = new Date(bVal).getTime();
      }
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR');
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return `${date.toLocaleDateString('tr-TR')} ${date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}`;
  };

  // View job detail
  const handleViewJob = (job) => {
    setSelectedJob(job);
    setDetailModalOpen(true);
    loadStockExitHistory(job.id);
    loadJobDocuments(job.id);
  };

  // Load stock list for stock exit
  const loadStockList = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/api/depot/stok-all`, { headers: getAuthHeaders() });
      setStockList(response.data || []);
    } catch (error) {
      console.error('Stok listesi yüklenirken hata:', error);
    }
  }, []);

  // Load subcontractors (taşeron firmalar)
  const loadSubcontractors = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/api/subcontractors`, { headers: getAuthHeaders() });
      setSubcontractors(response.data || []);
    } catch (error) {
      console.error('Taşeron firmalar yüklenirken hata:', error);
    }
  }, []);

  // Get all firma options (Fortis + Subcontractors)
  const firmaOptions = [
    { id: 'fortis', name: 'FORTİS' },
    ...subcontractors.map(s => ({ id: s.id, name: s.name }))
  ];

  // Filter stocks by search term
  const filteredStockList = stockList.filter(stock => 
    (stock.product_name || stock.urun_adi)?.toLowerCase().includes(stockSearchTerm.toLowerCase())
  );

  // Teslim alacak kullanıcıları yükle
  const loadTeslimAlanUsers = async () => {
    try {
      const response = await axios.get(`${API}/api/depot/users-for-selection`, { headers: getAuthHeaders() });
      setTeslimAlanUsers(response.data || []);
    } catch (error) {
      console.error('Kullanıcılar yüklenirken hata:', error);
    }
  };

  // Seçilen firmanın çalışanlarını yükle (teslim alan için)
  const loadFirmaEmployees = async (firmaId) => {
    try {
      const response = await axios.get(`${API}/api/depot/firma-employees/${firmaId}`, { headers: getAuthHeaders() });
      setFirmaEmployees(response.data || []);
    } catch (error) {
      console.error('Firma çalışanları yüklenirken hata:', error);
      setFirmaEmployees([]);
    }
  };

  // Open stock exit modal
  const openStockExitModal = (job) => {
    setSelectedJob(job);
    setStockExitItems([{ stok_karti_id: '', miktar: '', birim: '', urun_adi: '', mevcut_stok: 0, popoverOpen: false }]);
    setStockExitAciklama(`İş: ${job.name || job.title || ''} için stok çıkışı`);
    setStockSearchTerm('');
    setSelectedFirma('');
    setFirmaPopoverOpen(false);
    // Talep eden bilgilerini otomatik doldur - işi oluşturan kişi
    setTalepEdenId(job.created_by || '');
    setTalepEdenName(job.created_by_name || '');
    setTalepEdenPopoverOpen(false);
    // Teslim alan: önce firma seçilmeli, o yüzden başlangıçta boş
    setTeslimAlanId('');
    setTeslimAlanName('');
    setFirmaEmployees([]);
    setTeslimAlanPopoverOpen(false);
    setTeslimTarihi(new Date().toISOString().split('T')[0]); // Bugünün tarihi
    setTeslimBelgeleri([]);
    loadStockList();
    loadSubcontractors();
    loadTeslimAlanUsers();
    setStockExitModalOpen(true);
  };

  // Teslim alan kişiyi seç
  const handleTeslimAlanSelect = (userId, userName) => {
    setTeslimAlanId(userId);
    setTeslimAlanName(userName);
    setTeslimAlanPopoverOpen(false);
  };

  // Teslim belgesi yükleme (çoklu)
  const handleTeslimBelgesiSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setTeslimBelgeleri(prev => [...prev, ...files]);
    }
    // Input'u sıfırla ki aynı dosya tekrar seçilebilsin
    e.target.value = '';
  };

  // Tek belgeyi kaldır
  const removeTeslimBelgesi = (index) => {
    setTeslimBelgeleri(prev => prev.filter((_, i) => i !== index));
  };

  // Add new stock exit item
  const addStockExitItem = () => {
    setStockExitItems([...stockExitItems, { stok_karti_id: '', miktar: '', birim: '', urun_adi: '', mevcut_stok: 0, popoverOpen: false }]);
  };

  // Remove stock exit item
  const removeStockExitItem = (index) => {
    if (stockExitItems.length > 1) {
      setStockExitItems(stockExitItems.filter((_, i) => i !== index));
    }
  };

  // Update stock exit item
  const updateStockExitItem = (index, field, value) => {
    const newItems = [...stockExitItems];
    newItems[index][field] = value;
    
    // If selecting a product, update birim and mevcut_stok and close popover
    if (field === 'stok_karti_id') {
      const selectedStock = stockList.find(s => s.stok_karti_id === value);
      if (selectedStock) {
        newItems[index].birim = selectedStock.unit || selectedStock.birim || 'adet';
        newItems[index].urun_adi = selectedStock.product_name || selectedStock.urun_adi || '';
        newItems[index].mevcut_stok = (selectedStock.total_giris || 0) - (selectedStock.total_cikis || 0);
      }
    }
    
    setStockExitItems(newItems);
  };

  // Handle stock exit (multiple items)
  const handleStockExit = async () => {
    // Validate items
    const validItems = stockExitItems.filter(item => item.stok_karti_id && item.miktar);
    
    if (validItems.length === 0) {
      toast.error('Lütfen en az bir ürün seçin ve miktar girin');
      return;
    }

    if (!selectedFirma) {
      toast.error('Lütfen bir firma seçin');
      return;
    }
    
    if (!teslimAlanId || !teslimAlanName) {
      toast.error('Lütfen teslim alan kişiyi seçin');
      return;
    }
    
    if (!teslimTarihi) {
      toast.error('Lütfen teslim tarihini seçin');
      return;
    }

    // Check for insufficient stock
    for (const item of validItems) {
      if (parseFloat(item.miktar) <= 0) {
        toast.error(`${item.urun_adi}: Geçerli bir miktar girin`);
        return;
      }
      if (parseFloat(item.miktar) > item.mevcut_stok) {
        toast.error(`${item.urun_adi}: Yetersiz stok! Mevcut: ${item.mevcut_stok} ${item.birim}`);
        return;
      }
    }

    setStockExitLoading(true);
    try {
      // Format items for backend
      const formattedItems = validItems.map(item => ({
        stok_karti_id: item.stok_karti_id,
        quantity: parseFloat(item.miktar),
        unit: item.birim
      }));

      // Get firma name
      const firmaInfo = firmaOptions.find(f => f.id === selectedFirma);
      const firmaName = firmaInfo?.name || '';
      
      // Stok çıkışı oluştur - Tüm alanlar
      const response = await axios.post(`${API}/api/depot/stok-cikisleri`, {
        items: formattedItems,
        description: stockExitAciklama || `İş: ${selectedJob?.name || selectedJob?.title || ''} için stok çıkışı`,
        job_id: selectedJob?.id,
        requester_name: talepEdenName || selectedJob?.created_by_name || '',
        requester_id: talepEdenId || selectedJob?.created_by || '',
        receiver_name: teslimAlanName || '',
        receiver_id: teslimAlanId || '',
        deliverer_name: user?.name || '',
        deliverer_id: user?.id || '',
        taseron_firma: firmaName,
        teslim_alan: teslimAlanName,
        teslim_alan_id: teslimAlanId,
        teslim_tarihi: teslimTarihi
      }, { headers: getAuthHeaders() });
      
      const stokCikisId = response.data.id;
      
      // Teslim belgelerini yükle (varsa)
      if (teslimBelgeleri.length > 0 && stokCikisId) {
        let uploadedCount = 0;
        let failedCount = 0;
        
        for (const belge of teslimBelgeleri) {
          const formData = new FormData();
          formData.append('file', belge);
          
          try {
            await axios.post(`${API}/api/depot/stok-cikisleri/${stokCikisId}/teslim-belgesi`, formData, {
              headers: {
                ...getAuthHeaders(),
                'Content-Type': 'multipart/form-data'
              }
            });
            uploadedCount++;
          } catch (uploadError) {
            console.error('Teslim belgesi yükleme hatası:', uploadError);
            failedCount++;
          }
        }
        
        if (failedCount > 0 && uploadedCount > 0) {
          toast.warning(`${uploadedCount} belge yüklendi, ${failedCount} belge yüklenemedi`);
        } else if (failedCount > 0 && uploadedCount === 0) {
          toast.warning('Stok çıkışı yapıldı ancak belgeler yüklenemedi');
        }
      }
      
      toast.success(`${validItems.length} ürün için stok çıkışı başarıyla yapıldı`);
      triggerReload();
      setStockExitModalOpen(false);
      setStockExitItems([{ stok_karti_id: '', miktar: '', birim: '', urun_adi: '', mevcut_stok: 0, popoverOpen: false }]);
      setStockExitAciklama('');
      setSelectedFirma('');
      setTalepEdenId('');
      setTalepEdenName('');
      setTeslimAlanId('');
      setTeslimAlanName('');
      setTeslimTarihi('');
      setTeslimBelgeleri([]);
      // Refresh assigned jobs list and stock exit history
      loadAssignedJobs();
      if (selectedJob?.id) {
        loadStockExitHistory(selectedJob.id);
      }
    } catch (error) {
      console.error('Stok çıkışı hatası:', error);
      toast.error(error.response?.data?.detail || 'Stok çıkışı yapılırken hata oluştu');
    } finally {
      setStockExitLoading(false);
    }
  };

  // Open reject modal
  const openRejectModal = (job) => {
    setSelectedJob(job);
    setRejectReason('');
    setRejectModalOpen(true);
  };

  // Handle reject job
  const handleRejectJob = async () => {
    if (!rejectReason.trim()) {
      toast.error('Lütfen red sebebi girin');
      return;
    }

    setRejectLoading(true);
    try {
      await axios.put(`${API}/api/depot/assigned-jobs/${selectedJob.id}/reject`, {
        reason: rejectReason
      }, { headers: getAuthHeaders() });
      
      toast.success('İş reddedildi');
      triggerReload();
      setRejectModalOpen(false);
      setDetailModalOpen(false);
      setRejectReason('');
      // Refresh lists
      loadAssignedJobs();
      loadRejectedJobs();
    } catch (error) {
      console.error('İş reddetme hatası:', error);
      toast.error(error.response?.data?.detail || 'İş reddedilirken hata oluştu');
    } finally {
      setRejectLoading(false);
    }
  };

  // Open complete modal
  const openCompleteModal = (job) => {
    setSelectedJob(job);
    setCompleteNotes('');
    setCompleteModalOpen(true);
  };

  // Handle complete job
  const handleCompleteJob = async () => {
    setCompleteLoading(true);
    try {
      await axios.put(`${API}/api/depot/assigned-jobs/${selectedJob.id}/complete`, {
        notes: completeNotes
      }, { headers: getAuthHeaders() });
      
      toast.success('İş başarıyla tamamlandı');
      triggerReload();
      setCompleteModalOpen(false);
      setDetailModalOpen(false);
      setCompleteNotes('');
      // Refresh lists
      loadAssignedJobs();
      loadCompletedJobs();
    } catch (error) {
      console.error('İş tamamlama hatası:', error);
      toast.error(error.response?.data?.detail || 'İş tamamlanırken hata oluştu');
    } finally {
      setCompleteLoading(false);
    }
  };

  // ===== İş Ekle (Add Job) =====
  const loadBranchUsers = async () => {
    try {
      const response = await axios.get(`${API}/api/depot/users-for-selection`, { headers: getAuthHeaders() });
      setBranchUsers(response.data || []);
    } catch (error) {
      console.error('Şube kullanıcıları yüklenirken hata:', error);
    }
  };

  const openAddJobModal = () => {
    setAddJobForm({ hedef: 'branch', konu: '', aciklama: '', tracking_users: [], belgeler: [] });
    loadBranchUsers();
    setAddJobModalOpen(true);
  };

  const handleAddJobFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    const newBelgeler = [];
    for (const file of files) {
      const reader = new FileReader();
      const base64 = await new Promise((resolve) => {
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      newBelgeler.push({ name: file.name, size: file.size, type: file.type, url: base64 });
    }
    setAddJobForm((prev) => ({ ...prev, belgeler: [...prev.belgeler, ...newBelgeler] }));
    e.target.value = '';
  };

  const removeAddJobFile = (index) => {
    setAddJobForm((prev) => ({ ...prev, belgeler: prev.belgeler.filter((_, i) => i !== index) }));
  };

  const toggleTrackingUser = (userId) => {
    setAddJobForm((prev) => ({
      ...prev,
      tracking_users: prev.tracking_users.includes(userId)
        ? prev.tracking_users.filter((id) => id !== userId)
        : [...prev.tracking_users, userId],
    }));
  };

  const handleAddJobSubmit = async () => {
    if (!addJobForm.konu.trim()) {
      toast.error('İşin konusu zorunludur');
      return;
    }
    if (addJobForm.hedef === 'branch' && addJobForm.tracking_users.length === 0) {
      toast.error('En az bir çalışan seçmelisiniz');
      return;
    }
    setAddJobSubmitting(true);
    try {
      const response = await axios.post(`${API}/api/depot/jobs/create`, addJobForm, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'İş oluşturuldu');
      setAddJobModalOpen(false);
      setAddJobForm({ hedef: 'branch', konu: '', aciklama: '', tracking_users: [], belgeler: [] });
      loadAssignedJobs();
    } catch (error) {
      console.error('İş oluşturma hatası:', error);
      toast.error(error.response?.data?.detail || 'İş oluşturulamadı');
    } finally {
      setAddJobSubmitting(false);
    }
  };

  // Render assigned jobs table (branch_jobs with tracking_users)
  const renderAssignedJobsTable = (jobs, emptyMessage) => {
    const sortedJobs = sortJobs(jobs);
    
    if (sortedJobs.length === 0) {
      return (
        <div className="text-center py-12 text-gray-500">
          <Briefcase className="h-12 w-12 mx-auto mb-4 opacity-30" />
          <p>{emptyMessage}</p>
        </div>
      );
    }

    return (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="cursor-pointer" onClick={() => handleSort('name')}>
              <div className="flex items-center gap-1">
                İş Adı
                <ArrowUpDown className="h-4 w-4" />
              </div>
            </TableHead>
            <TableHead>Şirket</TableHead>
            <TableHead>İlerleme</TableHead>
            <TableHead>Takip Edenler</TableHead>
            <TableHead className="cursor-pointer" onClick={() => handleSort('created_at')}>
              <div className="flex items-center gap-1">
                Oluşturulma
                <ArrowUpDown className="h-4 w-4" />
              </div>
            </TableHead>
            <TableHead>Oluşturan</TableHead>
            <TableHead>Durum</TableHead>
            <TableHead className="text-right">İşlemler</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sortedJobs.map((job) => {
            const status = getStatusBadge(job.status);
            return (
              <TableRow key={job.id} data-testid={`assigned-job-row-${job.id}`}>
                <TableCell className="font-medium">
                  <div className="flex items-center gap-2">
                    <Briefcase className="h-4 w-4 text-purple-500" />
                    {job.name || job.title || '-'}
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-1 text-gray-600">
                    <Building2 className="h-4 w-4" />
                    {job.company || '-'}
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <div className="w-24 h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div 
                        className="h-full bg-purple-500 rounded-full transition-all"
                        style={{ width: `${job.progress || 0}%` }}
                      />
                    </div>
                    <span className="text-sm text-gray-600">%{job.progress || 0}</span>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex -space-x-2">
                    {job.tracking_user_details?.slice(0, 3).map((u, idx) => (
                      <div
                        key={u.id}
                        className="w-7 h-7 rounded-full bg-purple-100 border-2 border-white flex items-center justify-center text-xs font-medium text-purple-700"
                        title={u.name}
                      >
                        {u.name?.charAt(0)?.toUpperCase() || '?'}
                      </div>
                    ))}
                    {(job.tracking_user_details?.length || 0) > 3 && (
                      <div className="w-7 h-7 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs font-medium text-gray-600">
                        +{job.tracking_user_details.length - 3}
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-sm">
                  <div>{formatDate(job.created_at)}</div>
                  <div className="text-xs text-gray-500">
                    {new Date(job.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </TableCell>
                <TableCell className="text-sm">
                  {job.created_by_name || '-'}
                </TableCell>
                <TableCell>
                  <Badge className={job.status === 'active' ? 'bg-blue-100 text-blue-800' : status.className}>
                    {job.status === 'active' ? 'Devam Ediyor' : status.label}
                  </Badge>
                </TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleViewJob(job)}
                    data-testid={`view-assigned-job-${job.id}`}
                  >
                    <Eye className="h-4 w-4 mr-1" />
                    Detay
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };

  // Render jobs table
  const renderJobsTable = (jobs, emptyMessage) => {
    const sortedJobs = sortJobs(jobs);
    
    if (sortedJobs.length === 0) {
      return (
        <div className="text-center py-12 text-gray-500">
          <Briefcase className="h-12 w-12 mx-auto mb-4 opacity-30" />
          <p>{emptyMessage}</p>
        </div>
      );
    }

    return (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="cursor-pointer" onClick={() => handleSort('title')}>
              <div className="flex items-center gap-1">
                İş Başlığı
                <ArrowUpDown className="h-4 w-4" />
              </div>
            </TableHead>
            <TableHead>Açıklama</TableHead>
            <TableHead className="cursor-pointer" onClick={() => handleSort('created_at')}>
              <div className="flex items-center gap-1">
                Tarih
                <ArrowUpDown className="h-4 w-4" />
              </div>
            </TableHead>
            <TableHead>Oluşturan</TableHead>
            <TableHead>Durum</TableHead>
            <TableHead className="text-right">İşlemler</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sortedJobs.map((job) => {
            const status = getStatusBadge(job.status);
            return (
              <TableRow key={job.id} data-testid={`job-row-${job.id}`}>
                <TableCell className="font-medium">
                  <div className="flex items-center gap-2">
                    <Briefcase className="h-4 w-4 text-emerald-500" />
                    {job.title || job.name || job.konu || '-'}
                  </div>
                </TableCell>
                <TableCell className="max-w-xs truncate text-gray-600">
                  {job.description || job.aciklama || '-'}
                </TableCell>
                <TableCell className="text-sm">
                  <div>{formatDate(job.created_at)}</div>
                  <div className="text-xs text-gray-500">
                    {new Date(job.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </TableCell>
                <TableCell className="text-sm">
                  {job.created_by_name || '-'}
                </TableCell>
                <TableCell>
                  <Badge className={status.className}>{status.label}</Badge>
                </TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleViewJob(job)}
                    data-testid={`view-job-${job.id}`}
                  >
                    <Eye className="h-4 w-4 mr-1" />
                    Detay
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-600" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="depot-jobs">
      {/* İş Paneli ile birebir İşler sayfası (aktif/ara verilen/tamamlanan/iptal/iletilenler + arşiv) */}
      <WorkJobs
        depotMode
        reloadSignal={reloadSignal}
        renderHeaderActions={() => (
          !readOnly ? (
            <Button
              onClick={openAddJobModal}
              className="gap-2 bg-emerald-600 hover:bg-emerald-700"
              data-testid="depot-add-job-btn"
            >
              <Plus className="h-4 w-4" />
              İş Ekle
            </Button>
          ) : null
        )}
        renderExtraDetailActions={(job, closeModal) => (
          !readOnly && job ? (
            <>
              {job.status !== 'completed' && job.status !== 'cancelled' && (
                <Button
                  onClick={() => { closeModal(); openStockExitModal(job); }}
                  className="gap-2 bg-emerald-600 hover:bg-emerald-700"
                  data-testid="depot-detail-stock-exit-btn"
                >
                  <Package className="h-4 w-4" />
                  Stok Çıkış Ekle
                </Button>
              )}
              {job.status === 'active' && (
                <>
                  <Button
                    onClick={() => { closeModal(); openCompleteModal(job); }}
                    className="gap-2 bg-blue-600 hover:bg-blue-700"
                    data-testid="depot-detail-complete-btn"
                  >
                    <CheckCircle className="h-4 w-4" />
                    Tamamla
                  </Button>
                  <Button
                    variant="destructive"
                    onClick={() => { closeModal(); openRejectModal(job); }}
                    className="gap-2"
                    data-testid="depot-detail-reject-btn"
                  >
                    <XCircle className="h-4 w-4" />
                    Reddet
                  </Button>
                </>
              )}
              {(job.purchasing_job_id || job.source === 'purchasing' || job.source_type === 'purchasing') && job.status !== 'completed' && job.status !== 'cancelled' && (
                <Button
                  onClick={() => { setSelectedJob(job); openTransferModal(); }}
                  className="gap-2 bg-amber-600 hover:bg-amber-700"
                  data-testid="depot-detail-transfer-btn"
                >
                  <ArrowLeftRight className="h-4 w-4" />
                  Başka Depoya Transfer Et
                </Button>
              )}
            </>
          ) : null
        )}
      />

      {/* İş Ekle (Add Job) Modal */}
      <Dialog open={addJobModalOpen} onOpenChange={setAddJobModalOpen}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="depot-add-job-modal">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Plus className="h-5 w-5 text-emerald-600" />
              Yeni İş Ekle
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            {/* Hedef Seçimi */}
            <div>
              <Label>Hedef *</Label>
              <Select
                value={addJobForm.hedef}
                onValueChange={(value) => setAddJobForm((prev) => ({ ...prev, hedef: value }))}
              >
                <SelectTrigger data-testid="add-job-hedef-select">
                  <SelectValue placeholder="Hedef seçin" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="branch">Şube Çalışanları (İşler paneline düşer)</SelectItem>
                  <SelectItem value="purchasing">Satın Alma Paneli (Onay Bekleyen)</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {/* Konu */}
            <div>
              <Label>Konu *</Label>
              <Input
                value={addJobForm.konu}
                onChange={(e) => setAddJobForm((prev) => ({ ...prev, konu: e.target.value }))}
                placeholder="İşin konusu..."
                data-testid="add-job-konu-input"
              />
            </div>

            {/* Açıklama */}
            <div>
              <Label>Açıklama</Label>
              <Textarea
                value={addJobForm.aciklama}
                onChange={(e) => setAddJobForm((prev) => ({ ...prev, aciklama: e.target.value }))}
                placeholder="İş hakkında detaylar..."
                rows={4}
                data-testid="add-job-aciklama-input"
              />
            </div>

            {/* Şube Çalışanları seçimi (sadece hedef=branch) */}
            {addJobForm.hedef === 'branch' && (
              <div>
                <Label>Çalışanlar * (İş bu kişilerin İşler panelinde görünür)</Label>
                <Popover open={trackingUsersPopoverOpen} onOpenChange={setTrackingUsersPopoverOpen}>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      role="combobox"
                      className="w-full justify-between font-normal"
                      data-testid="add-job-users-trigger"
                    >
                      <span className="truncate">
                        {addJobForm.tracking_users.length > 0
                          ? `${addJobForm.tracking_users.length} çalışan seçildi`
                          : 'Çalışan seçin...'}
                      </span>
                      <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
                    <Command>
                      <CommandInput placeholder="Çalışan ara..." />
                      <CommandList>
                        <CommandEmpty>Çalışan bulunamadı</CommandEmpty>
                        <CommandGroup>
                          {branchUsers.map((u) => (
                            <CommandItem
                              key={u.id}
                              value={u.name}
                              onSelect={() => toggleTrackingUser(u.id)}
                              data-testid={`add-job-user-${u.id}`}
                            >
                              <Check
                                className={cn(
                                  'mr-2 h-4 w-4',
                                  addJobForm.tracking_users.includes(u.id) ? 'opacity-100' : 'opacity-0'
                                )}
                              />
                              <div className="flex flex-col">
                                <span>{u.name}</span>
                                {u.panel_display && (
                                  <span className="text-xs text-gray-500">{u.panel_display}</span>
                                )}
                              </div>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
                {addJobForm.tracking_users.length > 0 && (
                  <div className="flex flex-wrap gap-1 mt-2">
                    {addJobForm.tracking_users.map((uid) => {
                      const u = branchUsers.find((x) => x.id === uid);
                      return (
                        <Badge key={uid} variant="secondary" className="gap-1">
                          {u?.name || uid}
                          <button onClick={() => toggleTrackingUser(uid)} className="ml-1 text-red-500 hover:text-red-700">
                            <XCircle className="h-3 w-3" />
                          </button>
                        </Badge>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {/* Belgeler */}
            <div>
              <Label>Belgeler</Label>
              <div className="border-2 border-dashed rounded-lg p-4">
                <input
                  type="file"
                  multiple
                  onChange={handleAddJobFileUpload}
                  className="hidden"
                  id="depot-job-file-upload"
                />
                <label
                  htmlFor="depot-job-file-upload"
                  className="flex flex-col items-center cursor-pointer text-gray-500 hover:text-gray-700"
                >
                  <Upload className="h-8 w-8 mb-2" />
                  <span className="text-sm">Dosya yüklemek için tıklayın</span>
                </label>
              </div>
              {addJobForm.belgeler.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {addJobForm.belgeler.map((file, index) => (
                    <div key={index} className="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded text-sm">
                      <FileText className="h-3 w-3" />
                      {file.name}
                      <button onClick={() => removeAddJobFile(index)} className="ml-1 text-red-500 hover:text-red-700">
                        <XCircle className="h-3 w-3" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setAddJobModalOpen(false)} disabled={addJobSubmitting}>
              İptal
            </Button>
            <Button
              onClick={handleAddJobSubmit}
              disabled={addJobSubmitting}
              className="bg-emerald-600 hover:bg-emerald-700"
              data-testid="add-job-submit-btn"
            >
              {addJobSubmitting ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Plus className="h-4 w-4 mr-2" />}
              Ekle
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>


      {/* Stok Çıkış Modal */}
      <Dialog open={stockExitModalOpen} onOpenChange={setStockExitModalOpen}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Package className="h-5 w-5 text-emerald-600" />
              Stok Çıkışı Yap
            </DialogTitle>
            <DialogDescription>
              {selectedJob?.name || selectedJob?.title} işi için stok çıkışı yapın.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {/* Seçilen Ürünler Listesi */}
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <Label>Çıkış Yapılacak Ürünler</Label>
                <Button 
                  type="button" 
                  variant="outline" 
                  size="sm" 
                  onClick={addStockExitItem}
                  className="gap-1"
                >
                  <Plus className="h-4 w-4" />
                  Ürün Ekle
                </Button>
              </div>

              {stockExitItems.map((item, index) => {
                const selectedStock = stockList.find(s => s.stok_karti_id === item.stok_karti_id);
                const selectedStockName = selectedStock ? (selectedStock.product_name || selectedStock.urun_adi) : null;
                
                return (
                <div key={index} className="p-3 border rounded-lg bg-gray-50 space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-600">Ürün #{index + 1}</span>
                    {stockExitItems.length > 1 && (
                      <Button 
                        type="button" 
                        variant="ghost" 
                        size="sm" 
                        onClick={() => removeStockExitItem(index)}
                        className="h-6 w-6 p-0 text-red-500 hover:text-red-700"
                      >
                        <XCircle className="h-4 w-4" />
                      </Button>
                    )}
                  </div>

                  {/* Ürün Seçimi - Aranabilir Combobox */}
                  <div className="space-y-2">
                    <Label className="text-xs">Ürün Seçin *</Label>
                    <Popover 
                      open={item.popoverOpen} 
                      onOpenChange={(open) => {
                        const newItems = [...stockExitItems];
                        newItems[index].popoverOpen = open;
                        setStockExitItems(newItems);
                      }}
                    >
                      <PopoverTrigger asChild>
                        <Button
                          variant="outline"
                          role="combobox"
                          aria-expanded={item.popoverOpen}
                          className="w-full justify-between"
                          data-testid={`stock-exit-product-${index}`}
                        >
                          {selectedStockName || "Ürün ara ve seç..."}
                          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent className="w-[400px] p-0" align="start">
                        <Command>
                          <CommandInput placeholder="Ürün adı yazın..." />
                          <CommandList>
                            <CommandEmpty>Ürün bulunamadı.</CommandEmpty>
                            <CommandGroup>
                              {stockList.map((stock) => {
                                const available = (stock.total_giris || 0) - (stock.total_cikis || 0);
                                const stockName = stock.product_name || stock.urun_adi || 'Ürün';
                                const stockUnit = stock.unit || stock.birim || 'adet';
                                const isDisabled = available <= 0;
                                
                                return (
                                  <CommandItem
                                    key={stock.stok_karti_id}
                                    value={stockName}
                                    disabled={isDisabled}
                                    onSelect={() => {
                                      if (!isDisabled) {
                                        updateStockExitItem(index, 'stok_karti_id', stock.stok_karti_id);
                                        const newItems = [...stockExitItems];
                                        newItems[index].popoverOpen = false;
                                        setStockExitItems(newItems);
                                      }
                                    }}
                                    className={cn(
                                      "flex items-center justify-between",
                                      isDisabled && "opacity-50 cursor-not-allowed"
                                    )}
                                  >
                                    <div className="flex items-center gap-2">
                                      <Check
                                        className={cn(
                                          "h-4 w-4",
                                          item.stok_karti_id === stock.stok_karti_id ? "opacity-100" : "opacity-0"
                                        )}
                                      />
                                      <span>{stockName}</span>
                                    </div>
                                    <Badge 
                                      variant={available > 0 ? 'default' : 'destructive'} 
                                      className="text-xs ml-2"
                                    >
                                      {available} {stockUnit}
                                    </Badge>
                                  </CommandItem>
                                );
                              })}
                            </CommandGroup>
                          </CommandList>
                        </Command>
                      </PopoverContent>
                    </Popover>
                  </div>

                  {/* Seçilen ürün bilgisi */}
                  {item.stok_karti_id && (
                    <div className="flex items-center justify-between p-2 bg-blue-50 rounded border border-blue-200">
                      <span className="text-sm text-blue-700">
                        <strong>{item.urun_adi}</strong>
                      </span>
                      <Badge className="bg-blue-100 text-blue-800">
                        Mevcut: {item.mevcut_stok} {item.birim}
                      </Badge>
                    </div>
                  )}

                  {/* Miktar ve Birim */}
                  <div className="flex gap-2 items-end">
                    <div className="flex-1 space-y-1">
                      <Label className="text-xs">Çıkış Miktarı *</Label>
                      <Input
                        type="number"
                        min="0.01"
                        step="0.01"
                        placeholder="Miktar"
                        value={item.miktar}
                        onChange={(e) => updateStockExitItem(index, 'miktar', e.target.value)}
                        data-testid={`stock-exit-quantity-${index}`}
                      />
                    </div>
                    <div className="w-20 pb-0.5">
                      <Badge variant="outline" className="w-full justify-center py-2">
                        {item.birim || 'birim'}
                      </Badge>
                    </div>
                  </div>

                  {/* Stok uyarısı */}
                  {item.miktar && item.mevcut_stok > 0 && parseFloat(item.miktar) > item.mevcut_stok && (
                    <div className="flex items-center gap-2 text-red-600 text-xs">
                      <AlertTriangle className="h-3 w-3" />
                      Yetersiz stok! Mevcut: {item.mevcut_stok} {item.birim}
                    </div>
                  )}
                </div>
              );
              })}
            </div>

            {/* Teslim Bilgileri */}
            <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg space-y-4">
              <h4 className="font-medium text-blue-800 flex items-center gap-2">
                <User className="h-4 w-4" />
                Teslim Bilgileri
              </h4>
              
              {/* Talep Eden - Dropdown */}
              <div className="space-y-2">
                <Label className="flex items-center gap-2">
                  <User className="h-4 w-4" />
                  Talep Eden *
                </Label>
                <Popover open={talepEdenPopoverOpen} onOpenChange={setTalepEdenPopoverOpen}>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      role="combobox"
                      aria-expanded={talepEdenPopoverOpen}
                      className="w-full justify-between bg-white"
                      data-testid="stock-exit-talep-eden-select"
                    >
                      {talepEdenName || "Talep eden kişiyi seçin..."}
                      <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-[350px] p-0" align="start">
                    <Command>
                      <CommandInput placeholder="Kişi ara..." />
                      <CommandList>
                        <CommandEmpty>Kişi bulunamadı.</CommandEmpty>
                        <CommandGroup heading="Kullanıcılar">
                          {teslimAlanUsers.map((u) => (
                            <CommandItem
                              key={u.id}
                              value={u.name}
                              onSelect={() => {
                                setTalepEdenId(u.id);
                                setTalepEdenName(u.name);
                                setTalepEdenPopoverOpen(false);
                              }}
                            >
                              <Check
                                className={cn(
                                  "mr-2 h-4 w-4",
                                  talepEdenId === u.id ? "opacity-100" : "opacity-0"
                                )}
                              />
                              <div className="flex flex-col">
                                <span>{u.name}</span>
                                {u.panel_display && (
                                  <span className="text-xs text-gray-500">{u.panel_display}</span>
                                )}
                              </div>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
              </div>
              
              {/* Teslim Alan Adı Soyadı - Dropdown */}
              <div className="space-y-2">
                <Label className="flex items-center gap-2">
                  <User className="h-4 w-4" />
                  Teslim Alan Adı Soyadı *
                </Label>
                <Popover open={teslimAlanPopoverOpen} onOpenChange={setTeslimAlanPopoverOpen}>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      role="combobox"
                      aria-expanded={teslimAlanPopoverOpen}
                      className="w-full justify-between bg-white"
                      disabled={!selectedFirma}
                      data-testid="stock-exit-teslim-alan-select"
                    >
                      {teslimAlanName || (selectedFirma ? "Kişi seçin..." : "Önce firma seçin")}
                      <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-[350px] p-0" align="start">
                    <Command>
                      <CommandInput placeholder="Kişi ara..." />
                      <CommandList>
                        <CommandEmpty>Bu firmada çalışan bulunamadı.</CommandEmpty>
                        <CommandGroup heading="Firma Çalışanları">
                          {firmaEmployees.map((u) => (
                            <CommandItem
                              key={u.id}
                              value={u.name}
                              onSelect={() => handleTeslimAlanSelect(u.id, u.name)}
                            >
                              <Check
                                className={cn(
                                  "mr-2 h-4 w-4",
                                  teslimAlanId === u.id ? "opacity-100" : "opacity-0"
                                )}
                              />
                              <div className="flex flex-col">
                                <span>{u.name}</span>
                                {u.role && (
                                  <span className="text-xs text-gray-500">{u.role}</span>
                                )}
                              </div>
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
              </div>
              
              {/* Teslim Tarihi */}
              <div className="space-y-2">
                <Label className="flex items-center gap-2">
                  <Calendar className="h-4 w-4" />
                  Teslim Tarihi *
                </Label>
                <Input
                  type="date"
                  value={teslimTarihi}
                  onChange={(e) => setTeslimTarihi(e.target.value)}
                  data-testid="stock-exit-teslim-tarihi-input"
                />
              </div>
              
              {/* Teslim Tutanağı Belgesi - Çoklu */}
              <div className="space-y-2">
                <Label className="flex items-center gap-2">
                  <FileText className="h-4 w-4" />
                  Teslim Tutanağı Belgeleri
                </Label>
                <div className="space-y-2">
                  {/* Belge Ekleme Butonu */}
                  <div className="flex items-center gap-2">
                    <Input
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      onChange={handleTeslimBelgesiSelect}
                      className="hidden"
                      multiple
                      id="teslim-belgesi-input"
                      data-testid="stock-exit-teslim-belgesi-input"
                    />
                    <Button
                      type="button"
                      variant="outline"
                      onClick={() => document.getElementById('teslim-belgesi-input').click()}
                      className="gap-2"
                    >
                      <Upload className="h-4 w-4" />
                      Belge Ekle
                    </Button>
                    <span className="text-xs text-gray-500">PDF, Word veya resim dosyası (birden fazla seçebilirsiniz)</span>
                  </div>
                  
                  {/* Eklenen Belgeler Listesi */}
                  {teslimBelgeleri.length > 0 && (
                    <div className="space-y-1 max-h-32 overflow-y-auto">
                      {teslimBelgeleri.map((belge, index) => (
                        <div key={index} className="flex items-center gap-2 p-2 bg-white border rounded">
                          <FileText className="h-4 w-4 text-blue-600 flex-shrink-0" />
                          <span className="text-sm flex-1 truncate">{belge.name}</span>
                          <span className="text-xs text-gray-400">{(belge.size / 1024).toFixed(1)} KB</span>
                          <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            onClick={() => removeTeslimBelgesi(index)}
                            className="h-6 w-6 p-0 text-red-500 hover:text-red-700 flex-shrink-0"
                          >
                            <XCircle className="h-4 w-4" />
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Firma Seçimi */}
            <div className="space-y-2">
              <Label>Firma *</Label>
              <Popover open={firmaPopoverOpen} onOpenChange={setFirmaPopoverOpen}>
                <PopoverTrigger asChild>
                  <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={firmaPopoverOpen}
                    className="w-full justify-between"
                    data-testid="stock-exit-firma-select"
                  >
                    {selectedFirma 
                      ? firmaOptions.find(f => f.id === selectedFirma)?.name || "Firma seçin..."
                      : "Firma ara ve seç..."}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-[400px] p-0" align="start">
                  <Command>
                    <CommandInput placeholder="Firma adı yazın..." />
                    <CommandList>
                      <CommandEmpty>Firma bulunamadı.</CommandEmpty>
                      <CommandGroup heading="Firmalar">
                        {firmaOptions.map((firma) => (
                          <CommandItem
                            key={firma.id}
                            value={firma.name}
                            onSelect={() => {
                              setSelectedFirma(firma.id);
                              setFirmaPopoverOpen(false);
                              // Firma değişince teslim alan listesini güncelle ve seçimi sıfırla
                              setTeslimAlanId('');
                              setTeslimAlanName('');
                              loadFirmaEmployees(firma.id);
                            }}
                          >
                            <Check
                              className={cn(
                                "mr-2 h-4 w-4",
                                selectedFirma === firma.id ? "opacity-100" : "opacity-0"
                              )}
                            />
                            <span className={firma.id === 'fortis' ? 'font-semibold text-emerald-700' : ''}>
                              {firma.name}
                            </span>
                            {firma.id === 'fortis' && (
                              <Badge className="ml-2 bg-emerald-100 text-emerald-700 text-xs">Ana Firma</Badge>
                            )}
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </Command>
                </PopoverContent>
              </Popover>
            </div>

            {/* Açıklama */}
            <div className="space-y-2">
              <Label htmlFor="description">Açıklama</Label>
              <Textarea
                id="description"
                placeholder="Çıkış açıklaması..."
                value={stockExitAciklama}
                onChange={(e) => setStockExitAciklama(e.target.value)}
                rows={2}
                data-testid="stock-exit-description-input"
              />
            </div>

            {/* Özet */}
            {stockExitItems.some(item => item.stok_karti_id && item.miktar) && (
              <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg">
                <p className="text-sm font-medium text-emerald-800 mb-2">Çıkış Özeti</p>
                <ul className="text-sm text-emerald-700 space-y-1">
                  {stockExitItems.filter(item => item.stok_karti_id && item.miktar).map((item, idx) => (
                    <li key={idx} className="flex justify-between">
                      <span>{item.urun_adi}</span>
                      <span className="font-medium">{item.miktar} {item.birim}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setStockExitModalOpen(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleStockExit} 
              disabled={stockExitLoading || !stockExitItems.some(item => item.stok_karti_id && item.miktar)}
              className="gap-2 bg-emerald-600 hover:bg-emerald-700"
            >
              {stockExitLoading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Minus className="h-4 w-4" />
              )}
              Çıkış Yap ({stockExitItems.filter(item => item.stok_karti_id && item.miktar).length} ürün)
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Reddetme Modal */}
      <Dialog open={rejectModalOpen} onOpenChange={setRejectModalOpen}>
        <DialogContent className="sm:max-w-[400px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <AlertTriangle className="h-5 w-5" />
              İşi Reddet
            </DialogTitle>
            <DialogDescription>
              {selectedJob?.name || selectedJob?.title} işini reddetmek istediğinize emin misiniz?
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="reject-reason">Red Sebebi *</Label>
              <Textarea
                id="reject-reason"
                placeholder="Neden reddediyorsunuz?"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                rows={3}
                data-testid="reject-reason-input"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setRejectModalOpen(false)}>
              İptal
            </Button>
            <Button 
              variant="destructive"
              onClick={handleRejectJob} 
              disabled={rejectLoading}
              className="gap-2"
            >
              {rejectLoading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <XCircle className="h-4 w-4" />
              )}
              Reddet
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Tamamlama Modal */}
      <Dialog open={completeModalOpen} onOpenChange={setCompleteModalOpen}>
        <DialogContent className="sm:max-w-[400px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-blue-600">
              <CheckCircle className="h-5 w-5" />
              İşi Tamamla
            </DialogTitle>
            <DialogDescription>
              {selectedJob?.name || selectedJob?.title} işini tamamlamak istediğinize emin misiniz?
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="complete-notes">Tamamlama Notu (İsteğe bağlı)</Label>
              <Textarea
                id="complete-notes"
                placeholder="İş hakkında not ekleyin..."
                value={completeNotes}
                onChange={(e) => setCompleteNotes(e.target.value)}
                rows={3}
                data-testid="complete-notes-input"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setCompleteModalOpen(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleCompleteJob} 
              disabled={completeLoading}
              className="gap-2 bg-blue-600 hover:bg-blue-700"
              data-testid="confirm-complete-btn"
            >
              {completeLoading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <CheckCircle className="h-4 w-4" />
              )}
              Tamamla
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Transfer Modal */}
      <Dialog open={transferModalOpen} onOpenChange={setTransferModalOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ArrowLeftRight className="h-5 w-5" />
              Başka Depoya Transfer Et
            </DialogTitle>
            <DialogDescription>
              Bu işi ve tüm belgelerini başka bir depoya transfer edin.
            </DialogDescription>
          </DialogHeader>
          <div className="py-4 space-y-4">
            <div>
              <label className="text-sm font-medium mb-2 block">Hedef Depo Seçin</label>
              <select
                value={transferDestinationBranch}
                onChange={(e) => setTransferDestinationBranch(e.target.value)}
                className="w-full p-2 border rounded-md"
              >
                <option value="">Depo Seçin...</option>
                {branchList.filter(b => b.id !== selectedJob?.branch_id && b.id !== selectedJob?.assigned_to_branch_id).map(branch => (
                  <option key={branch.id} value={branch.id}>{branch.name}</option>
                ))}
              </select>
            </div>
            {selectedJob?.documents && selectedJob.documents.length > 0 && (
              <div className="text-sm text-gray-600">
                <span className="font-medium">{selectedJob.documents.length} belge</span> transfer edilecek
              </div>
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setTransferModalOpen(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleTransferToDepot} 
              disabled={transferLoading || !transferDestinationBranch}
              className="gap-2 bg-amber-600 hover:bg-amber-700"
              data-testid="confirm-transfer-btn"
            >
              {transferLoading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <ArrowLeftRight className="h-4 w-4" />
              )}
              Transfer Et
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DepotJobs;
